<alert type="info" [dismissible]="true">{{ "forms.educationalResource.files.alert" | translate }}</alert>
<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
  <div class="form-group">
    <div class="row g-2 align-items-end">
      <div class="col" formGroupName="name">
        <label for="name">{{ "forms.educationalResource.files.materialName.label." + lang | translate }}&nbsp;*</label>
        <app-tooltip-button key="forms.educationalResource.files.materialName.tooltip" variant="help"></app-tooltip-button>
        <input
          type="text"
          class="form-control"
          id="name"
          [formControlName]="lang"
          [attr.aria-invalid]="name.invalid && (name.dirty || name.touched || submitted)"
          [attr.aria-describedby]="
            name.invalid && (name.dirty || name.touched || submitted) ? 'name-error' : null
          "
          [ngClass]="{ 'is-invalid': name.invalid && (name.dirty || name.touched || submitted) }" />
        @if (name.invalid && (name.dirty || name.touched || submitted)) {
          <div
            id="name-error"
            class="invalid-feedback">
            @if (name.errors?.['invalidCharacters']) {
              <div>{{ "forms.errors.textInput.characters" | translate }}</div>
            }
            @if (name.errors?.['maxlength']) {
              <div>
                {{ "forms.errors.common.maxLength" | translate: { maxLength: name.errors?.['maxlength']['requiredLength'] }
                }}
              </div>
            }
          </div>
        }
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-gray"
          (click)="openModal(nameI18n)"
          [ngClass]="{ 'is-invalid': names.get(otherLangs[0]).invalid || names.get(otherLangs[1]).invalid }">
          {{ "forms.common.translations.label" | translate }}
        </button>
        <app-tooltip-button key="forms.common.translations.tooltip" variant="help"></app-tooltip-button>
        @if (names.get(otherLangs[0]).invalid || names.get(otherLangs[1]).invalid) {
          <div
            class="invalid-feedback">
            {{ "forms.errors.common.translations" | translate }}
          </div>
        }
      </div>
    </div>

    <!-- Modal for the language versions -->
    <ng-template #nameI18n>
      <div class="modal-header">
        <h5 class="modal-title">{{ "forms.educationalResource.files.materialName.modal.title" | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          [attr.aria-label]="'forms.common.close' | translate"
          (click)="modalRef.hide()"></button>
      </div>
      <div class="modal-body" formGroupName="name">
        <h4>{{ "forms.educationalResource.files.materialName.modal.subtitle" | translate }}</h4>
        <div class="form-group">
          <label for="name2">
            {{ "forms.educationalResource.files.materialName.label." + otherLangs[0] | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            id="name2"
            [formControlName]="otherLangs[0]"
            [ngClass]="{
              'is-invalid':
                names.get(otherLangs[0]).invalid &&
                (names.get(otherLangs[0]).dirty || names.get(otherLangs[0]).touched || submitted)}" />
          @if (
            names.get(otherLangs[0]).invalid &&
            (names.get(otherLangs[0]).dirty || names.get(otherLangs[0]).touched || submitted)) {
            <div
              class="invalid-feedback">
              @if (names.get(otherLangs[0]).errors?.['invalidCharacters']) {
                <div>
                  {{ "forms.errors.textInput.characters" | translate }}
                </div>
              }
              @if (names.get(otherLangs[0]).errors?.['maxlength']) {
                <div>
                  {{ "forms.errors.common.maxLength" | translate: { maxLength:
                  names.get(otherLangs[0]).errors?.['maxlength']['requiredLength'] } }}
                </div>
              }
            </div>
          }
        </div>
        <div class="form-group">
          <label for="name3">
            {{ "forms.educationalResource.files.materialName.label." + otherLangs[1] | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            id="name3"
            [formControlName]="otherLangs[1]"
            [ngClass]="{
              'is-invalid':
                names.get(otherLangs[1]).invalid &&
                (names.get(otherLangs[1]).dirty || names.get(otherLangs[1]).touched || submitted)}" />
          @if (
            names.get(otherLangs[1]).invalid &&
            (names.get(otherLangs[1]).dirty || names.get(otherLangs[1]).touched || submitted)) {
            <div
              class="invalid-feedback">
              @if (names.get(otherLangs[1]).errors?.['invalidCharacters']) {
                <div>
                  {{ "forms.errors.textInput.characters" | translate }}
                </div>
              }
              @if (names.get(otherLangs[1]).errors?.['maxlength']) {
                <div>
                  {{ "forms.errors.common.maxLength" | translate: { maxLength:
                  names.get(otherLangs[1]).errors?.['maxlength']['requiredLength'] } }}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-gray"
          [attr.aria-label]="'forms.common.cancel' | translate"
          (click)="modalRef.hide()">
          {{ "forms.common.cancel" | translate }}
        </button>
        <button type="button" class="btn btn-blue" (click)="modalRef.hide()">
          {{ "forms.common.saveChanges" | translate }}
        </button>
      </div>
    </ng-template>
  </div>

  @for (file of files.controls; track file; let i = $index) {
    <fieldset class="form-group border-bottom" formArrayName="files">
      <ng-container [formGroupName]="i">
        <h4>
          {{ i + 1 }}{{ "forms.educationalResource.files.file.title" | translate }}
          <app-tooltip-button key="forms.educationalResource.files.file.tooltip" variant="help"></app-tooltip-button>
        </h4>
        <div class="row g-2 align-items-end">
          @if (!file.get('link').value) {
            <div class="form-group col-lg">
              <label for="{{ 'file' + i }}">
                {{ "forms.educationalResource.files.file.inputs.file.label" | translate }}&nbsp;*
              </label>
              <input
                type="file"
                class="form-control"
                id="{{ 'file' + i }}"
                [lang]="lang"
                (change)="onFileChange($event, i)" />
              @if (file.get('file')?.hasError('fileTooLarge')) {
                <div class="invalid-feedback d-block">
                  {{ "forms.educationalResource.files.file.errors.tooLarge" | translate }}
                </div>
              }
            </div>
          }
          @if (!file.get('file').value && !file.get('link').value) {
            <div class="form-group col-lg-1 text-center">
              {{ "forms.educationalResource.files.file.or" | translate }}
            </div>
          }
          @if (!file.get('file').value) {
            <div class="form-group col-lg">
              <label for="{{ 'link' + i }}">
                {{ "forms.educationalResource.files.file.inputs.link.label" | translate }}&nbsp;*
              </label>
              <input
                type="url"
                class="form-control"
                id="{{ 'link' + i }}"
                formControlName="link"
              [ngClass]="{
                'is-invalid':
                  file.get('link').invalid && (file.get('link').dirty || file.get('link').touched || submitted)}" />
              @if (file.get('link').invalid && (file.get('link').dirty || file.get('link').touched || submitted)) {
                <div
                  class="invalid-feedback">
                  @if (file.get('link').errors?.['pattern']) {
                    <div>{{ "forms.common.pattern.url" | translate }}</div>
                  }
                  @if (file.get('link').errors?.['maxlength']) {
                    <div>
                      {{ "forms.errors.common.maxLength" | translate: { maxLength:
                      file.get("link").errors?.['maxlength']['requiredLength'] } }}
                    </div>
                  }
                </div>
              }
            </div>
          }
          <div class="form-group col-lg-2">
            <label [for]="'language' + i">
              {{ "forms.educationalResource.files.file.inputs.language.label" | translate }}&nbsp;*
            </label>
            <app-tooltip-button key="forms.educationalResource.files.file.inputs.language.tooltip" variant="help"></app-tooltip-button>
            <ng-select
              [items]="languages"
              bindLabel="value"
              bindValue="key"
              [id]="'language' + i"
              [labelForId]="'language' + i"
            formControlName="language"></ng-select>
            @if (
              file.get('language').invalid &&
              (file.get('language').dirty || file.get('language').touched || submitted)) {
              @if (file.get('language').errors?.['required']) {
                <div>
                  <small class="text-danger">{{ "forms.common.required" | translate }}</small>
                </div>
              }
            }
          </div>
        </div>
        <div class="row g-2 align-items-end" formGroupName="displayName">
          <div class="form-group col">
            <label for="{{ 'displayName' + i }}">
              {{ "forms.educationalResource.files.file.inputs.displayName.label." + lang | translate }}&nbsp;*
            </label>
            <app-tooltip-button key="forms.educationalResource.files.file.inputs.displayName.tooltip" variant="help"></app-tooltip-button>
            <input
              type="text"
              class="form-control"
              id="{{ 'displayName' + i }}"
              [formControlName]="lang"
              [ngClass]="{
                'is-invalid':
                  files.at(i).get('displayName.' + lang).invalid &&
                  (files.at(i).get('displayName.' + lang).dirty ||
                    files.at(i).get('displayName.' + lang).touched ||
                    submitted)}" />
            @if (
              files.at(i).get('displayName.' + lang).invalid &&
              (files.at(i).get('displayName.' + lang).dirty ||
              files.at(i).get('displayName.' + lang).touched ||
              submitted)) {
              <div
                class="invalid-feedback">
                @if (files.at(i).get('displayName.' + lang).errors?.['required']) {
                  <div>
                    {{ "forms.common.required" | translate }}
                  </div>
                }
                @if (files.at(i).get('displayName.' + lang).errors?.['invalidCharacters']) {
                  <div>
                    {{ "forms.errors.textInput.characters" | translate }}
                  </div>
                }
                @if (files.at(i).get('displayName.' + lang).errors?.['maxlength']) {
                  <div>
                    {{ "forms.errors.common.maxLength" | translate: { maxLength: files.at(i).get("displayName." +
                    lang).errors?.['maxlength']['requiredLength'] } }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group col-auto">
            <button
              type="button"
              class="btn btn-gray"
              (click)="openModal(displayName)"
              [ngClass]="{
                'is-invalid':
                  files.at(i).get('displayName.' + otherLangs[0]).invalid ||
                  files.at(i).get('displayName.' + otherLangs[1]).invalid}">
              {{ "forms.common.translations.label" | translate }}
            </button>
            <app-tooltip-button key="forms.common.translations.tooltip" variant="help"></app-tooltip-button>
            @if (
              files.at(i).get('displayName.' + otherLangs[0]).invalid ||
              files.at(i).get('displayName.' + otherLangs[1]).invalid) {
              <div
                class="invalid-feedback">
                {{ "forms.errors.common.translations" | translate }}
              </div>
            }
          </div>
          <ng-template #displayName>
            <div class="modal-header">
              <h5 class="modal-title">
                {{ "forms.educationalResource.files.file.inputs.displayName.modal.title" | translate }}
              </h5>
              <button
                type="button"
                class="btn-close"
                [attr.aria-label]="'forms.common.close' | translate"
                (click)="modalRef.hide()"></button>
            </div>
            <div class="modal-body">
              <h4>{{ "forms.educationalResource.files.file.inputs.displayName.modal.subtitle" | translate }}</h4>
              <div class="form-group">
                <label for="{{ 'displayName2' + i }}">
                  {{ "forms.educationalResource.files.file.inputs.displayName.label." + otherLangs[0] | translate }}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'displayName2' + i }}"
                  [formControlName]="otherLangs[0]"
                  [ngClass]="{
                    'is-invalid':
                      files.at(i).get('displayName.' + otherLangs[0]).invalid &&
                      (files.at(i).get('displayName.' + otherLangs[0]).dirty ||
                        files.at(i).get('displayName.' + otherLangs[0]).touched ||
                        submitted)}" />
                @if (
                  files.at(i).get('displayName.' + otherLangs[0]).invalid &&
                  (files.at(i).get('displayName.' + otherLangs[0]).dirty ||
                  files.at(i).get('displayName.' + otherLangs[0]).touched ||
                  submitted)) {
                  <div
                    class="invalid-feedback">
                    @if (files.at(i).get('displayName.' + otherLangs[0]).errors?.['invalidCharacters']) {
                      <div>
                        {{ "forms.errors.textInput.characters" | translate }}
                      </div>
                    }
                    @if (files.at(i).get('displayName.' + otherLangs[0]).errors?.['maxlength']) {
                      <div>
                        {{ "forms.errors.common.maxLength" | translate : { maxLength: files.at(i).get("displayName." +
                        otherLangs[0]).errors?.['maxlength']['requiredLength'] } }}
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <label for="{{ 'displayName3' + i }}">
                  {{ "forms.educationalResource.files.file.inputs.displayName.label." + otherLangs[1] | translate }}
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'displayName3' + i }}"
                  [formControlName]="otherLangs[1]"
                  [ngClass]="{
                    'is-invalid':
                      files.at(i).get('displayName.' + otherLangs[1]).invalid &&
                      (files.at(i).get('displayName.' + otherLangs[1]).dirty ||
                        files.at(i).get('displayName.' + otherLangs[1]).touched ||
                        submitted)}" />
                @if (
                  files.at(i).get('displayName.' + otherLangs[1]).invalid &&
                  (files.at(i).get('displayName.' + otherLangs[1]).dirty ||
                  files.at(i).get('displayName.' + otherLangs[1]).touched ||
                  submitted)) {
                  <div
                    class="invalid-feedback">
                    @if (files.at(i).get('displayName.' + otherLangs[1]).errors?.['invalidCharacters']) {
                      <div>
                        {{ "forms.errors.textInput.characters" | translate }}
                      </div>
                    }
                    @if (files.at(i).get('displayName.' + otherLangs[1]).errors?.['maxlength']) {
                      <div>
                        {{ "forms.errors.common.maxLength" | translate : { maxLength: files.at(i).get("displayName." +
                        otherLangs[1]).errors?.['maxlength']['requiredLength'] } }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-gray"
                [attr.aria-label]="'forms.common.cancel' | translate"
                (click)="modalRef.hide()">
                {{ "forms.common.cancel" | translate }}
              </button>
              <button type="button" class="btn btn-blue" (click)="modalRef.hide()">
                {{ "forms.common.saveChanges" | translate }}
              </button>
            </div>
          </ng-template>
        </div>
        @if (videoFiles.includes(i)) {
          @for (subtitle of file.get('subtitles')['controls']; track subtitle; let j = $index; let isLast = $last) {
            <div
              class="border-top pt-1"
              [ngClass]="{ 'border-bottom mb-2': isLast }">
              <fieldset formArrayName="subtitles">
                <div class="row g-2 align-items-end" [formGroupName]="j">
                  <div class="form-group col-lg order-1">
                    <label for="{{ 'subtitle' + i + j }}">
                      {{ "forms.educationalResource.files.file.inputs.subtitles.subtitle" | translate }}&nbsp;*
                    </label>
                    <input
                      type="file"
                      class="form-control"
                      id="{{ 'subtitle' + i + j }}"
                      accept=".vtt"
                      [lang]="lang"
                      (change)="onSubtitleChange($event, i, j)" />
                  </div>
                  <div class="form-group col-sm-8 col-lg order-2">
                    <label for="{{ 'label' + i + j }}">
                      {{ "forms.educationalResource.files.file.inputs.subtitles.label" | translate }}&nbsp;*
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="{{ 'label' + i + j }}"
                      formControlName="label"
                    [ngClass]="{
                      'is-invalid':
                        subtitle.get('label').invalid &&
                        (subtitle.get('label')['dirty'] || subtitle.get('label').touched || submitted)}" />
                    @if (
                      subtitle.get('label').invalid &&
                      (subtitle.get('label')['dirty'] || subtitle.get('label').touched || submitted)) {
                      <div
                        class="invalid-feedback">
                        @if (subtitle.get('label').errors?.['required']) {
                          <div>
                            {{ "forms.common.required" | translate }}
                          </div>
                        }
                        @if (subtitle.get('label').errors?.['invalidCharacters']) {
                          <div>
                            {{ "forms.errors.textInput.characters" | translate }}
                          </div>
                        }
                        @if (subtitle.get('label').errors?.['maxlength']) {
                          <div>
                            {{ "forms.errors.common.maxLength" | translate: { maxLength:
                            subtitle.get("label").errors?.['maxlength']['requiredLength'] } }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group col-sm-4 col-lg order-3">
                    <label [for]="'srclang' + i + j">
                      {{ "forms.educationalResource.files.file.inputs.subtitles.srclang" | translate }}&nbsp;*
                    </label>
                    <ng-select
                      [items]="languages"
                      bindLabel="value"
                      bindValue="key"
                      [id]="'srclang' + i + j"
                      [labelForId]="'srclang' + i + j"
                    formControlName="srclang"></ng-select>
                    @if (subtitle.get('srclang').invalid &&
                      (subtitle.get('srclang')['dirty'] || subtitle.get('srclang').touched || submitted)) {
                      @if (subtitle.get('srclang').errors?.['required']) {
                        <div>
                          <small class="text-danger">{{ "forms.common.required" | translate }}</small>
                        </div>
                      }
                    }
                  </div>
                  <div class="form-group col-lg-auto order-last order-lg-4">
                    <button type="button" class="btn btn-danger" (click)="removeSubtitle(i, j)">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                      <span class="visually-hidden">{{ "forms.common.delete" | translate }}</span>
                    </button>
                  </div>
                  <div class="form-group col-lg-12 order-4">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="{{ 'default' + i + j }}"
                        formControlName="default"
                        (change)="updateDefaultSubtitle($event, i, j)" />
                      <label class="form-check-label" for="{{ 'default' + i + j }}">
                        {{ "forms.educationalResource.files.file.inputs.subtitles.default" | translate }}
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          }
          <div class="row g-2">
            <div class="form-group col">
              <button type="button" class="btn btn-gray" (click)="addSubtitle(i)">
                {{ "forms.educationalResource.files.file.inputs.subtitles.addSubtitle" | translate }}
              </button>
            </div>
          </div>
        }
      </ng-container>
      @if ((uploadResponses$ | async)![i]; as ur) {
        @if (ur.visible === true) {
          <div class="form-group">
            <progressbar
              [type]="ur.status === 'error' ? 'danger' : 'success'"
              [value]="+ur.message">
              {{ ur.message }} {{ +ur.message <= 100 ? ' %' : '' }}
            </progressbar>
          </div>
        }
      }
    </fieldset>
  }
  @if (submitted && files.errors) {
    <div class="alert alert-warning" role="alert">
      @if (files.errors?.['required']) {
        <div>{{ "forms.educationalResource.files.file.error" | translate }}</div>
      }
    </div>
  }
  <div class="form-group">
    <button type="button" class="btn btn-gray" (click)="addFile()" [disabled]="hasUploadIssues">
      {{ "forms.educationalResource.files.file.addFile" | translate }}
    </button>
  </div>
  @if ((uploadedFiles$ | async)?.length > 0) {
    <h3>{{ "forms.educationalResource.files.uploadedFiles.title" | translate }}</h3>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.fileOrLink" | translate }}</th>
          <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.language" | translate }}</th>
          <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.subtitles" | translate }}</th>
          <th scope="col">{{ "forms.educationalResource.files.uploadedFiles.actions" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (upload of (uploadedFiles$ | async); track upload; let i = $index) {
          <tr>
            <th scope="row">{{ i + 1 }}</th>
            <td>{{ upload.file || upload.link || 'processing' }}</td>
            <td>{{ upload.language }}</td>
            <td>
              @for (subtitle of upload.subtitles; track subtitle; let isLast = $last) {
                <div
                  [class.font-weight-bold]="subtitle.default"
                  [class.mb-1]="!isLast">
                  {{ subtitle.label || '-' }} ({{ subtitle.srclang || '-' }})
                  @if (subtitle.label) {
                    <button
                      type="button"
                      class="btn btn-sm btn-danger"
                      (click)="setAttachmentObsoleted(subtitle.id)">
                      {{ "forms.common.delete" | translate }}
                    </button>
                  }
                </div>
              }
              @if (upload.subtitles.length === 0) {
                <span>-</span>
              }
            </td>
            <td>
              @if (upload.file) {
                <button
                  type="button"
                  class="btn btn-sm btn-danger"
                  (click)="setMaterialObsoleted(upload.id)">
                  {{ "forms.common.delete" | translate }}
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
  @if (uploadActive) {
    <div class="alert alert-success text-center" role="alert">{{ uploadActiveText }}</div>
  }
  @if (hasUploadIssues) {
    <div class="alert alert-danger text-center" role="alert">{{ uploadErrorText }}</div>
  }
  @if (hasEncryptedFiles) {
    <div class="alert alert-danger text-center" role="alert">{{ uploadEncryptedText }}</div>
  }
  <div class="row justify-content-end">
    <div class="col-auto">
      <!-- Abort | Discard -->
      @if (hasUploadIssues && !uploadActive) {
        <button
          type="submit"
          class="btn btn-cancel"
          [disabled]="uploadActive"
          (click)="clearUploadInformationAndContinue()">
          {{ "forms.common.discard" | translate }}
        </button>
      } @else {
        <button type="reset" class="btn btn-cancel" (click)="abort()">{{ "forms.common.abort" | translate }}</button>
      }
    </div>
    <div class="col-auto">
      <!-- Submit | Retry -->
      @if (!hasUploadIssues) {
        <button
          type="submit"
          class="btn btn-blue"
          [disabled]="(!form.valid && !form.touched) || uploadActive"
          [ngClass]="hasUploadIssues ? 'btn-danger' : 'btn-primary'">
          {{ "forms.common.next" | translate }}
        </button>
      } @else {
        <button type="submit" class="btn btn-danger" [disabled]="uploadActive">
          {{ "forms.common.retry" | translate }}
        </button>
      }
    </div>
  </div>
</form>
